/*
 * HALI – Shopify-Forms-App: eckige Ecken
 * ---------------------------------------------------------------
 * Die Shopify-Forms-App ("shopify://apps/forms") rendert ihr Formular
 * in einem OFFENEN Shadow-DOM (<shopify-forms-embed>). Die Inputs,
 * Textareas und der Submit-Button haben dort hartcodiert border-radius:5px.
 * Weil das im Shadow-DOM liegt, greift normales Theme-CSS nicht hinein und
 * die App bietet keinen Radius-Schalter. Deshalb injizieren wir ein <style>
 * direkt in den Shadow-Root, das den Radius auf 0 setzt – passend zum
 * eckigen HALI-Stil (Buttons/Inputs sind im Theme bereits radius 0).
 *
 * Das Embed lädt asynchron, daher pollen wir kurz, bis der Shadow-Root da ist.
 */
(function () {
  var CSS = 'input,textarea,select,button{border-radius:0 !important}';

  function patch(host) {
    var root = host.shadowRoot; // null, solange das Embed seinen Shadow-Root noch nicht angehängt hat
    if (!root) return false;
    if (!root.querySelector('style[data-hali-radius]')) {
      var style = document.createElement('style');
      style.setAttribute('data-hali-radius', '');
      style.textContent = CSS;
      root.appendChild(style);
    }
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    var pending = false;
    for (var i = 0; i < hosts.length; i++) {
      if (!patch(hosts[i])) pending = true;
    }
    // Fertig, sobald alle vorhandenen Forms gepatcht sind – oder nach ~10s aufgeben.
    if ((hosts.length && !pending) || ++tries > 40) clearInterval(timer);
  }, 250);
})();
